// extracted by mini-css-extract-plugin
export default {"container":"select-bank-id-method-tab-select-bank-id-method-tab_container","bankIdButtonsContainer":"select-bank-id-method-tab-select-bank-id-method-tab_bankIdButtonsContainer"};